import { render, staticRenderFns } from "./soa-login.vue?vue&type=template&id=209c17e3&scoped=true&"
import script from "./soa-login.vue?vue&type=script&lang=js&"
export * from "./soa-login.vue?vue&type=script&lang=js&"
import style0 from "./soa-login.vue?vue&type=style&index=0&id=209c17e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209c17e3",
  null
  
)

export default component.exports